import React from 'react';
import { Users, CreditCard, Database, Bell } from 'lucide-react';

/**
 * Konten halaman Dashboard dengan statistik dan area chart
 * @param {boolean} isDarkMode - Status dark mode
 */
const DashboardContent = ({ isDarkMode }) => {
    const stats = [
        {
            title: "Total Users",
            value: "12,450",
            change: "+12%",
            icon: Users,
            color: "text-blue-500",
            bg: isDarkMode ? "bg-blue-900/20" : "bg-blue-50"
        },
        {
            title: "Revenue",
            value: "$45,231",
            change: "+5.4%",
            icon: CreditCard,
            color: "text-emerald-500",
            bg: isDarkMode ? "bg-emerald-900/20" : "bg-emerald-50"
        },
        {
            title: "Active Cards",
            value: "3,204",
            change: "-1.2%",
            icon: Database,
            color: "text-purple-500",
            bg: isDarkMode ? "bg-purple-900/20" : "bg-purple-50"
        },
        {
            title: "Pending Issues",
            value: "14",
            change: "0%",
            icon: Bell,
            color: "text-amber-500",
            bg: isDarkMode ? "bg-amber-900/20" : "bg-amber-50"
        },
    ];

    /**
     * Menentukan warna badge berdasarkan nilai perubahan
     */
    const getChangeColor = (change) => {
        if (change.startsWith('+')) {
            return isDarkMode ? 'bg-emerald-900/30 text-emerald-400' : 'bg-emerald-100 text-emerald-700';
        }
        return isDarkMode ? 'bg-rose-900/30 text-rose-400' : 'bg-rose-100 text-rose-700';
    };

    return (
        <div className="space-y-4 animate-fade-in pb-20 md:pb-0">
            <h2 className="text-lg font-semibold">Dashboard Overview</h2>

            {/* Stats Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
                {stats.map((stat, idx) => (
                    <div
                        key={idx}
                        className={`p-4 rounded border transition-all ${isDarkMode ? 'bg-slate-800 border-slate-700' : 'bg-white border-slate-200'}`}
                    >
                        {/* Header: Icon & Badge */}
                        <div className="flex justify-between items-start mb-3">
                            <div className={`p-2 rounded ${stat.bg} ${stat.color}`}>
                                <stat.icon size={16} />
                            </div>
                            <span className={`text-[10px] font-medium px-1.5 py-0.5 rounded ${getChangeColor(stat.change)}`}>
                                {stat.change}
                            </span>
                        </div>

                        {/* Title & Value */}
                        <h3 className={`text-xs ${isDarkMode ? 'text-slate-400' : 'text-slate-500'}`}>
                            {stat.title}
                        </h3>
                        <p className="text-xl font-bold mt-1">{stat.value}</p>
                    </div>
                ))}
            </div>

            {/* Chart Placeholder */}
            <div className={`h-64 w-full rounded border flex items-center justify-center ${isDarkMode ? 'bg-slate-800 border-slate-700' : 'bg-white border-slate-200'}`}>
                <p className="text-xs text-slate-400">Chart Visualization Area</p>
            </div>
        </div>
    );
};

export default DashboardContent;
